var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItLayoutShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2394_81310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0585938 0.808594H58.4341V64.4418H0.0585938V0.808594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2394_81310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2394_81310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -36,
    y: -6,
    width: 154,
    height: 241
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.842 218.888L-4.7137 234.566L-35.373 9.93377L87.1829 -5.74414L117.842 218.888Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2394_81310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2394_81310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -36,
    y: -6,
    width: 154,
    height: 241
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.842 218.888L-4.7137 234.566L-35.373 9.93377L87.1829 -5.74414L117.842 218.888Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2394_81310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09144 35.7596C1.10397 35.7778 1.11023 35.796 1.12275 35.8142C1.14154 35.8385 1.16032 35.8566 1.18537 35.8748L37.6685 62.9201C37.6685 62.9262 37.6748 62.9262 37.681 62.9323C37.7311 62.9626 37.7875 62.9808 37.8438 62.9747L62.9236 62.4048C62.9424 62.4109 62.9612 62.4048 62.98 62.4048C62.98 62.4048 62.98 62.4048 62.98 62.3988C62.9988 62.3988 63.0238 62.3866 63.0426 62.3806C63.0802 62.3624 63.1178 62.3321 63.1428 62.3018C63.1491 62.2896 63.1553 62.2836 63.1616 62.2775L67.9145 54.4628L88.2101 40.8219C88.2163 40.8219 88.2226 40.8159 88.2289 40.8098C88.2727 40.7795 88.2978 40.731 88.3165 40.6885C88.3228 40.6704 88.3291 40.6522 88.3291 40.6279C88.3353 40.5734 88.3228 40.5188 88.2915 40.4703C88.2915 40.4703 88.2915 40.4703 88.2915 40.4642C88.2915 40.4642 88.2852 40.4582 88.2852 40.4521L66.6058 8.7204C66.6058 8.71434 66.6058 8.71434 66.6058 8.71434C66.5682 8.66584 66.5181 8.62946 66.4555 8.61127C66.4492 8.60521 66.4429 8.60521 66.4429 8.60521L35.3578 1.33614C35.3515 1.33614 35.3515 1.33614 35.3452 1.33614C35.3452 1.33008 35.3452 1.33614 35.339 1.33614C35.3139 1.33008 35.2826 1.33008 35.2576 1.33008C35.2325 1.33614 35.2012 1.3422 35.1762 1.35433C35.1574 1.36645 35.1386 1.37252 35.1261 1.38464L19.4708 12.9218C19.4645 12.9218 19.4582 12.9279 19.4582 12.9339H19.452C19.4457 12.94 19.4395 12.946 19.4332 12.9521C19.4144 12.9764 19.3956 13.0006 19.3831 13.0309C19.3831 13.0309 19.3831 13.0309 19.3831 13.037C19.3768 13.0491 19.3768 13.0552 19.3706 13.0673L15.4505 28.5754L1.22921 35.4201C1.22294 35.4201 1.22295 35.4262 1.22295 35.4262C1.16032 35.4565 1.12275 35.505 1.0977 35.5596C1.08518 35.5838 1.07892 35.6081 1.07892 35.6323C1.07265 35.6505 1.07265 35.6748 1.07892 35.693C1.07892 35.7172 1.08518 35.7415 1.09144 35.7596ZM2.58183 36.2386L29.5465 42.865L37.2176 61.9198L2.58183 36.2386ZM30.1414 42.8771L42.6281 41.8647L37.7687 61.8167L30.1414 42.8771ZM30.204 42.3376L40.236 21.4337L42.6782 41.3251L30.204 42.3376ZM38.182 62.4351L43.1353 42.1133L62.2974 61.8895L38.182 62.4351ZM51.2886 33.8924L55.8725 29.4545L62.6982 48.4062L51.2886 33.8924ZM62.6919 49.2732L43.4672 41.4767L50.9004 34.2743L62.6919 49.2732ZM50.9567 33.468L41.4195 21.3367L55.5406 29.0241L50.9567 33.468ZM50.5622 33.8499L43.1917 40.9917L40.787 21.4094L50.5622 33.8499ZM62.6794 61.5015L44.0684 42.2951L63.2493 50.0795L62.6794 61.5015ZM63.2493 61.071L63.7753 50.5524L67.3635 54.3112L63.2493 61.071ZM67.7455 53.9232L64.007 50.0128L85.9682 41.6828L67.7455 53.9232ZM63.6939 49.5521L56.4423 29.4121L87.2833 40.6097L63.6939 49.5521ZM87.3584 40.0641L56.3735 28.824L66.4116 9.39941L87.3584 40.0641ZM65.9733 9.04778L55.9476 28.4542L35.9589 2.02728L65.9733 9.04778ZM55.0146 28.1268L40.6305 20.2939L35.9276 2.88817L55.0146 28.1268ZM35.1323 2.05153L39.9917 20.0454L20.2034 13.0491L35.1323 2.05153ZM40.0168 20.6213L29.797 41.9193L20.0782 13.5766L40.0168 20.6213ZM19.6774 14.0979L29.1144 41.6343L15.989 28.6785L19.6774 14.0979ZM15.6258 29.0847L28.864 42.1496L2.13721 35.5778L15.6258 29.0847Z",
    fill: "#00C2CB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItLayoutShape4);
export default __webpack_public_path__ + "static/media/it-layout-shape-4.105096f346fe926fd1f9e0180bc9f009.svg";
export { ForwardRef as ReactComponent };